import React, { useState, useEffect } from "react";
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Button,
  TextField
} from "@mui/material";
import { ReactComponent as GenerateButton } from "../../../images/generateButton.svg";
import { useLocation, useNavigate } from "react-router-dom";
import CommonAccordion from "../../custom-components/CommonAccordion";
const ApiConfiguration = (props) => {
  const location = useLocation();
  const [apiFramework, setApiFramework] = useState("");
  const [programmingLanguage, setProgrammingLanguage] = useState("");
  const [codeStyle, setCodeStyle] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [testCases, setTestCases] = useState("");
  // const [formData, setFormData] = useState();


  const [isDisabled, setIsDisabled] = useState({
    apiTesting: true,
    programmingLanguage: true,
    codeStyle: true,
    testDataSource: true,
    environment: true,
  });
  const [formData, setFormData] = useState({
    baseurl: "",
    APIFramework: "",
    programmingLanguage: "",
    codeStyle: "",
    testDataSource: "",
    environment: "",
    projectType: "",
  });

  //const defaultLocatorsExpanded =;
  const navigate = useNavigate();
  // useEffect(() => {
  //   switch (formData.APIFramework) {
  //     case "rest-Assured-cucumber(BDD)":
  //       setFormData((prevState) => ({
  //         ...prevState,
  //         programmingLanguage: "Java",
  //         codeStyle: "POJO",
  //       }));
  //       break;
  //     case "C#":
  //       console.log("hiii");
  //       setFormData((prevState) => ({
  //         ...prevState,
  //         programmingLanguage: "C#",
  //         codeStyle: "POJO",
  //       }));
  //       break;
  //       case "karate_DSL":
  //         console.log("hiii");
  //         setFormData((prevState) => ({
  //           ...prevState,
  //           programmingLanguage: "Karate DSL",
  //           codeStyle: "POJO",
  //         }));
  //         break;
  //         case "PM_javascript":
  //           console.log("hiii");
  //           setFormData((prevState) => ({
  //             ...prevState,
  //             programmingLanguage: "PM JavaScript",
  //             codeStyle: "POJO",
  //           }));
  //           break;
  //     default:
  //       setFormData((prevState) => ({
  //         ...prevState,
  //         programmingLanguage: "",
  //         codeStyle: "",
  //       }));
  //   }
  // }, [formData.APIFramework]);
  useEffect(() => {
    const updateDependentFields = (framework) => {
      let programmingLanguage = "";
      let codeStyle = "";

      switch (framework) {
        case "java":
          programmingLanguage = "Java";
          codeStyle = "POJO";
          break;
        case "C#":
          programmingLanguage = "C#";
          codeStyle = "POJO";
          break;
        case "karate":
          programmingLanguage = "Karate";
          codeStyle = "POJO";
          break;
        case "javascript":
          programmingLanguage = "JavaScript";
          codeStyle = "POJO";
          break;
        default:
          break;
      }

      setFormData((prev) => ({
        ...prev,
        programmingLanguage,
        codeStyle,
      }));
    };

    updateDependentFields(formData.APIFramework);
  }, [formData.APIFramework]);


  useEffect(() => {
    setTestCases(location.state?.selectedTestCaseData || []);
  }, [location.state])


  const handleConfirm = async () => {
    if (formData.projectType === "new-project") {
      navigate(`/dashboard/api-testing/${formData.APIFramework}/${formData.projectType}`, {
        state: { framework: formData.APIFramework, testCaseData: testCases, projectType: formData.projectType, baseurl: formData.baseurl },
      });
    }
    else if (formData.projectType === "new-test-case" || formData.projectType === "modified-test-case") {
      const navigationState = { framework: formData.APIFramework, projectType: formData.projectType,testCaseData: testCases };
      console.log("Navigating to GitCredentialsPage with state:", navigationState);
      navigate(`/dashboard/api-testing/GitCredentialsPage`, {
        state: navigationState,
      });
    }
    
  };

  const buttonsgroup = [
    {
      label: "Confirm",
      variant: "contained",
      disabled: true,
      // startIcon: <GenerateButton />,
      onClick: handleConfirm,
    },
  ];

  return (
    <>

      {/* summary={"Configure Test Automation"} */}
      {/* details={ */}

      <Box
        sx={{
          border: "1px solid #ddd",
          borderRadius: "8px",
          padding: "16px",
          margin: "16px auto",
          //  width: "88%",
          position: "relative",
          backgroundColor: "#fff",
          //paddingTop: "8vh",
          width: {
            xs: "90%",  // extra-small screens
            sm: "90%",  // small screens
            md: "87%",  // medium screens
            lg: "87%",  // large screens
            xl: "75%",  // extra-large screens
          },
        }}
      >
        <Typography variant="h6" sx={{ mb: 2 }}>
          Configure Preferences
        </Typography>
        {/* Framework Dropdown */}
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", }}>

          <FormControl sx={{ my: 2, width: "95%" }}>
            <TextField
              label="Enter Base URL"
              name="url"
              value={formData?.baseurl || ""}
              onChange={(e) => {
                setFormData((prevState) => ({
                  ...prevState,
                  baseurl: e.target.value,
                }))
              }}
              // sx={{ width: "530px" }}
              variant="outlined"
              placeholder="https://mytestapp.com"
              autoComplete="off" // Disable autofill
            />
          </FormControl>
          <FormControl sx={{ my: 2, width: "95%" }} >
            <InputLabel>API Testing Framework</InputLabel>
            <Select
              fullWidth
              value={formData?.APIFramework || ""}
              onChange={(e) =>
                setFormData((prevState) => ({
                  ...prevState,
                  APIFramework: e.target.value,
                }))
              }
              label="UI Testing Framework"
            >
              <MenuItem value="java">Rest Assured - Cucumber (BDD)</MenuItem>
              <MenuItem value="C#" disabled>RestSharp - C# - SpecFlow(BDD)</MenuItem>
              <MenuItem value="C#" disabled>RestSharp - C# - ReqNRoll(BDD)</MenuItem>
              <MenuItem value="karate" disabled>Karate - DSL - Cucumber(BDD)</MenuItem>
              <MenuItem value="javascript" disabled>Playwright - TypeScript - PlaywrightTest(TDD)</MenuItem>
              <MenuItem value="javascript" disabled>Cypress - JavaScript - Mocha(TDD)</MenuItem>
              <MenuItem value="javascript" disabled>Postman - JavaScript (TDD)</MenuItem>







              {/* API Testing Frameworks": RestAssured - Java - Cucumber(BDD) RestSharp - C# - SpecFlow(BDD)
RestSharp - C# - ReqNRoll(BDD) Karate - DSL - Cucumber(BDD) Playwright - TypeScript - PlaywrightTest (TDD) Cypress - JavaScript - Mocha(TDD) Postman - JavaScript (TDD) */}
            </Select>
          </FormControl>
          <FormControl sx={{ my: 2, width: "95%" }} disabled={true}>
            <InputLabel>Programming Language</InputLabel>
            <Select
              value={formData?.programmingLanguage || ""}
              label="Programming Language"
              sx={{
                "& .MuiSelect-select": {
                  color: "black", // Ensures selected value text is black
                },
              }}
            >
              <MenuItem value="Java">Java</MenuItem>
              <MenuItem value="C#">C#</MenuItem>
              <MenuItem value="Python">Python</MenuItem>
              <MenuItem value="JavaScript">JavaScript</MenuItem>
              <MenuItem value="Karate">Karate</MenuItem>
            </Select>
          </FormControl>
          {/* Code Style Preferences */}
          <FormControl
            sx={{ my: 2, width: "95%" }}
            disabled={true}
          //style={codeStyle ? {  backgroundColor: "#e3f2fd"  } : {}}
          >
            <InputLabel>Code Style Preferences</InputLabel>
            <Select
              value={formData?.codeStyle || ""}
              label="Code Style Preferences"
            >
              <MenuItem value="Page Object Model (POM)">
                Page Object Model (POM)
              </MenuItem>
              <MenuItem value="Keywords">Keywords</MenuItem>
              <MenuItem value="POJO">POJO</MenuItem>
            </Select>
          </FormControl>
          {/* Test Data Source */}
          {/* <FormControl sx={{ my: 2, width: "95%" }} disabled={true}>
            <InputLabel>Test Data Source (Optional)</InputLabel>
            <Select value={formData.testDataSource} label="Test Data Source (Optional)">
              <MenuItem value="Excel">Excel</MenuItem>
              <MenuItem value="CSV">CSV</MenuItem>
              <MenuItem value="TXT">TXT</MenuItem>
              <MenuItem value="DOCX">DOCX</MenuItem>
              <MenuItem value="PDF">PDF</MenuItem>
              <MenuItem value="DB">DB</MenuItem>
            </Select>
          </FormControl> */}
          {/* Environment */}
          {/* <FormControl sx={{ my: 2, width: "95%" }} disabled={true}>
            <InputLabel>Environment</InputLabel>
            <Select value={formData.environment} label="Environment">
              <MenuItem value="A">A</MenuItem>
              <MenuItem value="B">B</MenuItem>
            </Select>
          </FormControl> */}
          <FormControl sx={{ my: 2, width: "95%" }} disabled={!formData.APIFramework}>
            <InputLabel>Project Type</InputLabel>
            <Select value={formData.projectType} label="Project Type" fontweight="bold"
              onChange={(e) =>
                setFormData((prevState) => ({
                  ...prevState,
                  projectType: e.target.value,
                }))
              }
            >
              <MenuItem value="new-project">New Test Case-New Project</MenuItem>
              <MenuItem value="new-test-case">New Test Case-Existing Project</MenuItem>
              <MenuItem value="modified-test-case">Modified Test Case-Existing Project</MenuItem>
            </Select>
          </FormControl>
        </Box>

        {/* Confirm Button */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            mt: 3,
          }}
        >
          <Button
            variant="contained"
            //startIcon={<GenerateButton />}
            sx={{
              textTransform: "none",
              px: 3,
            }}
            disabled={(!formData.APIFramework || !formData.projectType)} // Disable Confirm button if no framework selected
            // Disable Confirm button if no framework selected
            onClick={handleConfirm}
          >
            Confirm
          </Button>
        </Box>
      </Box>

      {/* buttons={buttonsgroup}
        fullScreenMode={true}
        type={"output"}
        defaultExpanded={defaultLocatorsExpanded} */}

    </>
  );
};
export default ApiConfiguration;
